// src/services/userService.js
// User management API calls

import api from './api';

// Get all users
export const getAllUsers = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/users?${params}`);
  return response.data;
};

// Get single user
export const getUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

// Create new user
export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

// Update user
export const updateUser = async (id, userData) => {
  const response = await api.put(`/users/${id}`, userData);
  return response.data;
};

// Delete user
export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

// Assign zone to user
export const assignZone = async (id, zone) => {
  const response = await api.post(`/users/${id}/assign-zone`, { zone });
  return response.data;
};

// Admin reset password
export const adminResetPassword = async (id, newPassword) => {
  const response = await api.post(`/users/${id}/reset-password`, { newPassword });
  return response.data;
};